export function getApi(dataStore, lastInRoute) {
    let lastRoute = lastInRoute;
    return {
        exec: dataStore.in.exec,
        getState: dataStore.getState.bind(dataStore),
        getReactiveState: dataStore.getReactive.bind(dataStore),
        setNext: (ev) => {
            lastRoute.setNext(ev.exec);
            lastRoute = ev;
        },
        getStores: () => ({ state: dataStore }),
        intercept: dataStore.in.on.bind(dataStore.in),
        on: dataStore.out.on.bind(dataStore.out),
        getSelection: (obj) => dataStore.getSelection(obj),
        eachSelected: (callback, sorted, reversed) => dataStore.eachSelected(callback, sorted, reversed),
        serialize: () => dataStore.serialize(),
        parse: (obj) => dataStore.parse(obj),
        existsTask: ({ id }) => dataStore.existsTask(id),
        existsProject: ({ id }) => dataStore.existsProject(id),
        getTask: ({ id }) => dataStore.getTask(id),
        getProject: ({ id }) => dataStore.getProject(id),
        hasChildren: ({ id, filtered, hideCompleted }) => dataStore.hasChildren(id, filtered, hideCompleted),
        getChildrenIds: (obj) => dataStore.getChildrenIds(obj),
        getParentIds: ({ id }) => dataStore.getParentIds(id),
        undo: () => dataStore.undo(),
        redo: () => dataStore.redo(),
    };
}
//# sourceMappingURL=api.js.map